import axios from 'axios'
import fileDownload from 'js-file-download'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getTransfers({ commit }, params = {}) {
    return axios.get('/transfers/search', { params })
  },
  getTransfer({ commit }, id) {
    return axios.get(`/transfers/${id}`)
  },
  createTransfer({ commit }, data) {
    return axios.post('/transfers', data)
  },
  updateTransfer({ commit }, data) {
    return axios.put(`/transfers/${data.id}`, data)
  },
  deleteTransfer({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/transfers/${payload.id}/delete`, payload)
  },
  rejectTransfer({ commit }, data) {
    const payload = {... data}
    if (! Object.prototype.hasOwnProperty.call(payload, 'is_check')){
      payload.is_check = 1
    }
    return axios.post(`/transfers/${payload.id}/reject`, payload)
  },
  confirmReceived({ commit }, data) {
    return axios.post(`/transfers/${data.id}/received`, data)
  },
  updateTransferStatus({ commit }, data) {
    return axios.put(`/transfers/${data.id}/change-status`, data)
  },
  downloadTransfer({ commit }, data) {
    return axios
      .get(`/transfers/${data.id}/download`, { responseType: 'blob' })
      .then((response) => {
        fileDownload(response.data, `${data.document_name}.pdf`)
      })
  },
}
